import { Swiper } from 'swiper';
import { Navigation, Pagination, Autoplay, A11y } from 'swiper/modules';

/**
 * Initialize flexible-content sliders
 */
export function initSliders(scope = document) {
  const sliders = scope.querySelectorAll('.js-slider');
  if (!sliders.length) {
    return;
  }

  sliders.forEach((el) => {
    if (el.swiper) return;
    const section = el.closest('.s-slider, .wx-slider, .wx-team, .band');
    const slides = el.querySelectorAll('.swiper-slide');
    const slideCount = slides.length;

    let options = {};
    if (el.dataset.options) {
      try {
        options = JSON.parse(el.dataset.options) ?? {};
      } catch (e) {
        options = {};
      }
    }

    // Determine the max slidesPerView requested across breakpoints
    const baseSlidesPerView = Number(options.slidesPerView) || 1;
    let maxSlidesPerView = baseSlidesPerView;
    if (options.breakpoints && typeof options.breakpoints === 'object') {
      Object.values(options.breakpoints).forEach((bp) => {
        if (bp && bp.slidesPerView) {
          maxSlidesPerView = Math.max(
            maxSlidesPerView,
            Number(bp.slidesPerView)
          );
        }
      });
    }

    // Swiper requires slideCount > slidesPerView to loop properly without glitches/warnings
    const canLoop = slideCount > maxSlidesPerView;

    const defaults = {
      modules: [Navigation, Pagination, Autoplay, A11y],
      loop: canLoop && options.loop !== false,
      speed: 650,
      spaceBetween: 20,
      slidesPerView: 1,
    };

    if (options.autoplay) {
      options.autoplay = {
        delay: 5000,
        pauseOnMouseEnter: true,
        disableOnInteraction: false,
      };
    }

    if (options.navigation && section) {
      options.navigation = {
        prevEl: section.querySelector('.swiper-button-prev, .slider-prev'),
        nextEl: section.querySelector('.swiper-button-next, .slider-next'),
      };
    }

    if (options.pagination && section) {
      options.pagination = {
        el: section.querySelector('.swiper-pagination, .slider-progress'),
        type: section.classList.contains('s-slider')
          ? 'bullets'
          : 'progressbar',
        clickable: true,
      };
    }

    // Override loop if not enough slides
    if (!canLoop && options.loop) {
      options.loop = false;
    }

    new Swiper(el, { ...defaults, ...options });
  });
}
